import { Button, Drawer, DrawerBody, DrawerContent, Stack, useDisclosure } from '@chakra-ui/react'
import { DocumentCollapse } from './DocumentCollapse'
import { ToggleButton } from './ToggleButton'
import { useNavigate } from 'react-router-dom'
import { useGlobalContext } from '../../context/GlobalContext';

export const MobileDrawer = () => {
    const { isOpen, onToggle, onClose } = useDisclosure()
    const navigate = useNavigate();
    const [{ config }] = useGlobalContext();

    const handleClick = (route) => {

        if (!config?.inOperation) {
            navigate(route);
        } else {
            alert('Esta en operación activa, termine la operación para poder acceder a esta sección');
        };
        onClose();

    };

    return (
        <>
            <ToggleButton
                isOpen={isOpen}
                onClick={onToggle}
                aria-label="Open menu"
                display={{
                    base: 'inline-flex',
                    lg: 'none',
                }}
            />
            <Drawer placement="top" isOpen={isOpen} onClose={onClose}>
                <DrawerContent>
                    <DrawerBody mt="72px" p="4">
                        <Stack spacing="1">
                            <Button onClick={() => handleClick('/dashboard')} size="lg" variant="tertiary" justifyContent="start">Tablero</Button>
                            <Button onClick={() => handleClick('/operations')} variant="tertiary" justifyContent="start">Operaciones</Button>
                            {/* <Button onClick={() => handleClick('/print')} variant="tertiary" justifyContent="start">Impresión</Button> */}


                            <DocumentCollapse />

                        </Stack>
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </>
    )
}